<template>
  <sticky-header-layout>
    <!-- <template #header>
      <div>
        <el-pagination
          :disabled="isLoading"
          :current-page="listQuery.page"
          :page-sizes="listQuery.sizes"
          :page-size="listQuery.size"
          :total="listQuery.total"
          background
          layout="total, sizes, pager, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </template> -->

    <search-panel
      :is-loading="isLoading"
      @search="handleSearch"
      @generateCSV="handleGenerateCSV"
    />

    <!-- Statistics Card -->
    <!-- <div class="mt-3">
      <statistics-card
        :data="{}"
      />
    </div> -->
    <!-- Statistics Card -->

    <!-- Orders Table -->
    <!-- <el-table
      v-loading="isLoading"
      :data="list"
      class="mt-3"
      border
      stripe
    >
      <el-table-column
        v-for="column in orderTableColumns"
        :key="column.type"
        :prop="column.type"
        :label="column.title || $t(`table.${column.type}`)"
        v-bind="column.custom"
      />

      <el-table-column
        :label="$t('table.action')"
        fixed="right"
        align="center"
        width="64"
      >
        <template #default="{ row }">
          <div class="button-group">
            <el-button
              size="mini"
              type="success"
              icon="el-icon-view"
              circle
              @click="handleShowOrderDetail(row)"
            />
          </div>
        </template>
      </el-table-column>
    </el-table> -->
    <!-- Orders Table -->

    <!-- Order Details -->
    <!-- <order-detail-dialog
      :is-open="showOrderDetailDialog"
      @close="showOrderDetailDialog = false"
    /> -->
  </sticky-header-layout>
</template>

<script>
import { mapGetters } from 'vuex'

import SearchPanel from './components/OrderSearchPanel.vue'
// import StatisticsCard from './components/StatisticsCard.vue'
// import OrderDetailDialog from './components/OrderDetailDialog.vue'

// import useTablePaging from '../../mixins/useTablePaging'
import {
  orderTableColumns,
  ORDER_API_BASE_URL,
} from '../../const/order'
import { getQueryString } from '../../utils/api'

export default {
  name: 'OrderList',
  components: {
    SearchPanel,
    // StatisticsCard,
    // OrderDetailDialog,
  },
  // mixins: [useTablePaging],
  data() {
    return {
      isLoading: false,
      showOrderDetailDialog: false,

      orderTableColumns,
    }
  },
  computed: {
    ...mapGetters({
      userToken: 'user/token',
    }),
  },
  mounted() {
    // this.listQuery.sizes = [10, 20, 50, 100]
  },
  methods: {
    // Handlers
    handleSearch() {

    },
    handleGenerateCSV(filters) {
      this.generateCSV(filters)
    },
    handleShowOrderDetail(row) {
      console.log(row);
      this.showOrderDetailDialog = true
    },
    // API Call
    async generateCSV(filters) {
      try {
        const qs = getQueryString({
          ...filters,
          token: this.userToken,
        })

        const link = document.createElement('a')
        link.href = `${ORDER_API_BASE_URL}/export_csv?${qs}`
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
      } catch (error) {
        console.error(error);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
</style>
